// -- see below import type { Component as Comp } from '@builder.io/sdk';
import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const LogoBar = dynamic(() => import('./LogoBar'));

Builder.registerComponent(LogoBar, {
	name: 'LogoBar',
	inputs: [
		{
			name: 'heading',
			friendlyName: 'Heading',
			type: 'string',
			required: false,
			defaultValue: 'As Seen On:',
		},
		{
			name: 'logos',
			friendlyName: 'Logos',
			type: 'list',
			subFields: [
				{
					name: 'logo',
					friendlyName: 'Logo',
					type: 'reference',
					model: 'logo',
				},
				{
					name: 'link',
					friendlyName: 'Link',
					type: 'string',
				},
			],

			/* TODO - Figure out types here. This seems to be the only way to
			 limit lists in Builder, but did not want this to hinder development.
			 seems like it should be Component as commented out above, but TS reports
			 that type does not have get/ set methods. In past repos its Map<string, string>
			 but that does not pass current rule set.
			*/
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			onChange: function (options: any) {
				if (options.get('logos').length > 3) {
					options.set('logos', options.get('logos').slice(0, 3));
					alert('maximum items is 3, delete items to continue');
				}
			},
			defaultValue: [
				{
					heading: 'As Seen On:',
					logos: [
						{
							logo: {
								'@type': '@builder.io/core:Reference',
								id: 'a1f2134f8df84c09a576303eae8a5de6',
								model: 'logo',
							},
						},
					],
				},
			],
		},
	],
	image: getIconUrl(Icon.LOGOBAR),
});
